
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LabelSpan({ comment }) {

  const { t } = useTranslation()

  return (
    <div>
      <b>{t('collaboratorComments.label')}: </b>
      <span>{comment}</span>
    </div>
  );
}